module.exports = __webpack_public_path__ + "img/spinner_pink.7d278992.svg";